export default "__VITE_ASSET__3kIGGo5I__"